import { render, staticRenderFns } from "./changePro.vue?vue&type=template&id=567ba671&scoped=true&"
import script from "./changePro.vue?vue&type=script&lang=js&"
export * from "./changePro.vue?vue&type=script&lang=js&"
import style0 from "./changePro.vue?vue&type=style&index=0&id=567ba671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ba671",
  null
  
)

export default component.exports